var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarpenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3946 21.6016C14.1613 21.6016 13.9323 21.5599 13.7076 21.4766C13.4823 21.3932 13.278 21.2599 13.0946 21.0766L11.7696 19.7766C11.603 19.5932 11.478 19.3976 11.3946 19.1896C11.3113 18.9809 11.2696 18.7682 11.2696 18.5516C11.253 18.3516 11.2823 18.1432 11.3576 17.9266C11.4323 17.7099 11.5446 17.5099 11.6946 17.3266L11.8946 17.0766L3.74463 5.42656L7.31963 1.85156L19.8196 14.3516C20.003 14.5349 20.1363 14.7389 20.2196 14.9636C20.303 15.1889 20.3446 15.4099 20.3446 15.6266C20.3446 15.8599 20.303 16.0889 20.2196 16.3136C20.1363 16.5389 20.003 16.7432 19.8196 16.9266L15.6696 21.0766C15.4863 21.2599 15.2823 21.3932 15.0576 21.4766C14.8323 21.5599 14.6113 21.6016 14.3946 21.6016ZM12.9446 16.0016L16.1696 12.8266L7.31963 3.97656L5.69463 5.60156L12.9446 16.0016ZM14.1946 20.0016C14.2446 20.0682 14.3113 20.1016 14.3946 20.1016C14.478 20.1016 14.553 20.0682 14.6196 20.0016L18.7446 15.8766C18.8113 15.8099 18.8446 15.7349 18.8446 15.6516C18.8446 15.5682 18.8113 15.5016 18.7446 15.4516L17.2196 13.8766L12.8446 18.2516C12.778 18.3182 12.7446 18.3932 12.7446 18.4766C12.7446 18.5599 12.778 18.6349 12.8446 18.7016L14.1946 20.0016Z",
    fill: "#2F2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpenter);
export default __webpack_public_path__ + "static/media/carpenter.9cc11be002c2624370f8a2e0c0df82d1.svg";
export { ForwardRef as ReactComponent };